module.exports = __webpack_public_path__ + "assets/img/circle.7d6fc730.svg";